import { Link } from 'react-router-dom';
import type { MapMetadata } from '@/types/api';
import { truncateText } from '@/lib/utils';
import { api } from '@/lib/api';

interface MapCardProps {
  map: MapMetadata;
}

export function MapCard({ map }: MapCardProps) {
  return (
    <Link
      to={`/maps/${map.id}`}
      className="block bg-shadow-700 rounded-lg shadow-dark hover:shadow-dark-lg transition-all overflow-hidden border border-stone-800 hover:border-stone-700 group"
    >
      <div className="h-48 bg-gradient-to-br from-shadow-600 to-shadow-700 flex items-center justify-center overflow-hidden">
        {map.preview_image_id ? (
          <img
            src={api.getThumbnailURL(map.preview_image_id)}
            alt={map.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        ) : (
          <svg
            className="w-16 h-16 text-stone-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            />
          </svg>
        )}
      </div>
      <div className="p-4 border-t border-stone-800">
        <h3 className="font-semibold text-xl text-stone-100 group-hover:text-gold-300 transition-colors">
          {truncateText(map.title, 60)}
        </h3>
      </div>
    </Link>
  );
}
